import { z } from 'zod';
import { FieldIdSchema, RangeDaysSchema } from './common.js';
import { LocaleSchema } from './locale.js';
/**
 * Через сколько минут кэш задач считается устаревшим.
 *
 * Это не расписание: обновление ставится в очередь при обращении к таблице, поэтому пока
 * никто не работает, запросов к Jira нет вовсе. Нижняя граница в две минуты защищает лимиты
 * Jira: чаще обновлять кэш всё равно бессмысленно, синхронизация столько и занимает.
 */
export const SYNC_INTERVAL_MIN_MINUTES = 2;
export const SYNC_INTERVAL_MAX_MINUTES = 1440;
export const SYNC_INTERVAL_DEFAULT_MINUTES = 10;
export const SyncIntervalMinutesSchema = z
    .number()
    .int()
    .min(SYNC_INTERVAL_MIN_MINUTES)
    .max(SYNC_INTERVAL_MAX_MINUTES);
/** Значения для выбора в настройках: от «почти сразу» до раза в сутки. */
export const SYNC_INTERVAL_CHOICES = [2, 5, 10, 15, 30, 60, 180, 720, 1440];
/**
 * Настройки тенанта. Оба поля Jira необязательны: пока они не выбраны, процент и дата начала
 * живут только в БД Jisy, и приложение работает без ошибок.
 */
export const TenantSettingsSchema = z.object({
    /** Числовое поле 0–100 для процента выполнения. */
    progressFieldId: FieldIdSchema.nullable(),
    progressFieldName: z.string().nullable(),
    /** Поле типа date/datetime для первой отмеченной даты. Последняя всегда идёт в duedate. */
    startDateFieldId: FieldIdSchema.nullable(),
    startDateFieldName: z.string().nullable(),
    defaultRangeDays: RangeDaysSchema,
    /** Выключатель записи в Jira: планы продолжают жить в Jisy, наружу ничего не уходит. */
    writeToJira: z.boolean(),
    syncIntervalMinutes: SyncIntervalMinutesSchema,
});
export const TenantSettingsUpdateSchema = z.object({
    progressFieldId: FieldIdSchema.nullable().optional(),
    startDateFieldId: FieldIdSchema.nullable().optional(),
    defaultRangeDays: RangeDaysSchema.optional(),
    writeToJira: z.boolean().optional(),
    syncIntervalMinutes: SyncIntervalMinutesSchema.optional(),
});
export const LocaleUpdateSchema = z.object({
    locale: LocaleSchema,
});
/** Кандидат в настройке поля: отбирается по типу схемы Jira. */
export const FieldCandidateSchema = z.object({
    id: FieldIdSchema,
    name: z.string(),
    /** number | date | datetime */
    type: z.string(),
    custom: z.boolean(),
});
export const FieldCandidatesSchema = z.object({
    progress: z.array(FieldCandidateSchema),
    startDate: z.array(FieldCandidateSchema),
});
/** Типы полей Jira, пригодные для процента выполнения. */
export const PROGRESS_FIELD_TYPES = ['number'];
/** Типы полей Jira, пригодные для даты начала. */
export const START_DATE_FIELD_TYPES = ['date', 'datetime'];
//# sourceMappingURL=settings.js.map